<template>
  <CustomerDetailPlaceholderTab title="Flujo de Efectivo" />
</template>

<script>
import CustomerDetailPlaceholderTab from '@/components/customers/detail/tabs/CustomerDetailPlaceholderTab.vue';

export default {
  name: 'CustomerDetailCashFlowTab',
  components: {
    CustomerDetailPlaceholderTab,
  },
};
</script>
